import Backbone from 'backbone';
import Section from './Section';

var SectionsCollection = Backbone.Collection.extend({
    model: Section,

    url: function() {
        var url = '/api/v1/events/'+ this.eventId + '/site';
        if (this.tabId) {
            return url + '/tabs/' + this.tabId;
        }
        return url;
    },

    parse: function(response) {
        this.fetched = true;
        return response;
    }
});

export default SectionsCollection;

